/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enddate1Inputs */

const en__field_enddate1 = /** @type {(inputs: _Field_Enddate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End Date`)
};

const de__field_enddate1 = /** @type {(inputs: _Field_Enddate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enddatum`)
};

/**
* | output |
* | --- |
* | "End Date" |
*
* @param {_Field_Enddate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enddate1 = /** @type {((inputs?: _Field_Enddate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enddate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enddate1(inputs)
	return de__field_enddate1(inputs)
});
export { _field_enddate1 as "_field_endDate" }